import { Feature } from "features/interfaces";
import { actions, reducer } from "./ducks";

export const modalFeature: Feature<typeof actions> = {
  reducer,
  actions
};
